import * as Sentry from '@sentry/browser';
import { BrowserTracing } from '@sentry/tracing';
import {
  sentryClientDsn,
  sentryConfig,
} from 'src/common/constants/analytics/sentry';
import shouldLogToSentry from '../../common/utils/shouldLogToSentry';
import vars from '../../common/vars';

if (shouldLogToSentry()) {
  const options = {
    ...sentryConfig,
    whitelistUrls: [/tunein\.com/],
    ignoreErrors: [
      "Failed to execute 'insertBefore' on 'Node': The node before which the new node is to be inserted is not a child of this node.",
    ],
    integrations: [
      new BrowserTracing({
        tracingOrigins: [
          new RegExp(`^https?://${vars.get('GEMINI_ORIGIN')}`),
          /^\//,
        ],
      }),
    ],
  };

  Sentry.init({
    dsn: sentryClientDsn,
    ...options,
  });
}
